import React, { useContext, useState } from "react";
import crypto from "crypto-js";
import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BSModalComponent from "./BSModal";
import { Link } from "react-router-dom";
import Select from "react-select";
import ManagerContext from "../../../Context/ManagerReportContext/ManagerReportContext";

const ManagerReportsTable = ({ reportsData, filtersData, fields, setPageNo }) => {
  let header = [];
  const { pageSize, setPageSize } = useContext(ManagerContext);
  const [modalBody, setModalBody] = useState("");
  const [modalHeader, setModalHeader] = useState("");
  const [modalShow, setModalShow] = useState(false);

  if (reportsData && reportsData.length > 0) {
    for (let a in reportsData[0]) {
      if (filtersData[a]) {
        header.push({
          value: filtersData[a]?.label + (filtersData[a]?.label.endsWith("Processing Time") ? " (hh:mm:ss)" : ""),
          key: a
        });
      }
    }
  } else {
    fields.forEach((key) => {
      if (filtersData[key]) {
        header.push({
          value: filtersData[key]?.label + (filtersData[key]?.label.endsWith("Processing Time") ? " (hh:mm:ss)" : ""),
          key
        });
      }
    });
  }

  const getTableDataForReportsTable = (item) => {
    let arr = [];
    let index = 0;
    for (let a in item) {
      let value = item[a];
      let tdKey = `${a}_${index}`;
      if (filtersData[a] !== undefined) {
        if (filtersData[a]["encrypted"]) {
          try {
            value = crypto.AES.decrypt(
              item[a] ?? "",
              process.env.REACT_APP_SECRET_PASS,
            ).toString(crypto.enc.Utf8);
          } catch (e) {
            console.log(e);
          }
        }
        if (!value) {
          value = "NA";
        }
        if (
          (a === "hold_reason" ||
            a === "resp_party_name" ||
            a === "primdiag_feedback_name" ||
            a === "secdiag_feedback_name" ||
            a === "modifier_feedback_name" ||
            a === "feedback_name" ||
            a === "procedure_feedback_name" ||
            a === "audit_options") &&
          value !== "NA"
        ) {
          let badges = [];
          value.split(", ").forEach((element, i) => {
            badges.push(
              <span key={i} className="badge badge-light mx-1 text-gray-800">
                {element}
              </span>,
            );
          });
          arr.push(<td key={tdKey}>{badges}</td>);
        } else if (a === "status_name") {
          switch (value) {
            case "Open":
              arr.push(
                <td key={tdKey}>
                  {" "}
                  <span className="text-info">{value}</span>{" "}
                </td>,
              );
              break;
            case "Complete":
              arr.push(
                <td key={tdKey}>
                  {" "}
                  <span className="text-success">{value}</span>{" "}
                </td>,
              );
              break;
            case "Incomplete":
              arr.push(
                <td key={tdKey}>
                  {" "}
                  <span className="text-danger">{value}</span>{" "}
                </td>,
              );
              break;
            default:
          }
        } else if (a === "milestone_name") {
          switch (value) {
            case "Ready to Allocate":
              arr.push(
                <td key={tdKey}>
                  {" "}
                  <span className="badge badge-light-dark fw-bold">
                    {value}
                  </span>{" "}
                </td>,
              );
              break;
            case "Ready to Code":
              arr.push(
                <td key={tdKey}>
                  {" "}
                  <span className="badge badge-light-info fw-bold">
                    {value}
                  </span>{" "}
                </td>,
              );
              break;
            case "Coding in Progress":
              arr.push(
                <td key={tdKey}>
                  {" "}
                  <span className="badge badge-light-primary fw-bold">
                    {value}
                  </span>{" "}
                </td>,
              );
              break;
            case "Coding Done":
              arr.push(
                <td key={tdKey}>
                  {" "}
                  <span className="badge badge-light-success fw-bold">
                    {value}
                  </span>{" "}
                </td>,
              );
              break;
            case "Ready to Audit":
              arr.push(
                <td key={tdKey}>
                  {" "}
                  <span className="badge badge-light-info fw-bold">
                    {value}
                  </span>{" "}
                </td>,
              );
              break;
            case "Audit in Progress":
              arr.push(
                <td key={tdKey}>
                  {" "}
                  <span className="badge badge-light-primary fw-bold">
                    {value}
                  </span>{" "}
                </td>,
              );
              break;
            case "Audit Done":
              arr.push(
                <td key={tdKey}>
                  {" "}
                  <span className="badge badge-success badge-outline fw-bold">
                    {value}
                  </span>{" "}
                </td>,
              );
              break;
            default:
          }
        } else if (a === "coder_comments" && value !== "NA") {
          arr.push(
            <td key={tdKey}>
              <OverlayTrigger
                key={"right"}
                placement={"top"}
                overlay={<Tooltip id="tooltip-right">{value}</Tooltip>}
              >
                <span className="comments-excerpt">{value}</span>
              </OverlayTrigger>
            </td>,
          );
        } else if (a === "comment_log" && value !== "NA") {
          arr.push(
            <td key={tdKey}>
              <span className="comments-excerpt">{value}</span>
              <Link
                onClick={() => {
                  setModalBody(value.replace(/\n/g, "<br/>"));
                  setModalHeader(
                    "Comment Log" +
                      (item["chart_no"]
                        ? " [Ch# " + item["chart_no"] + "]:"
                        : ":"),
                  );
                  setModalShow(true);
                }}
              >
                read more
              </Link>
            </td>,
          );
        } else if (a.endsWith("_processing_seconds") && value !== "NA") {
          arr.push(
            <td key={tdKey}>{moment.utc(value * 1000).format("HH:mm:ss")}</td>,
          );
        } else if (a === "worklist_no") {
          arr.push(
            <td key={tdKey}>
              {" "}
              <strong className="text-gray-900">{value}</strong>{" "}
            </td>,
          );
        } else {
          arr.push(<td key={tdKey}>{value}</td>);
        }
      }
      index++;
    }
    return arr;
  };
  const handlePageSizeUpdate = (e) => {
    setPageNo(1);
    setPageSize(e.value);
  };

  const pageSizeOptions = [
    { value: "10", label: "10" },
    { value: "25", label: "25" },
    { value: "50", label: "50" },
    { value: "75", label: "75" },
    { value: "100", label: "100" },
  ];

  return (
    <div
      className="card"
      style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
    >
      <div className="card-header border-0 pt-6">
        <h3 className="card-title align-items-start flex-column">
          <span className="card-label fw-bold text-gray-800">Reports</span>
        </h3>
        <div className="d-flex">
          <Select
            className="mt-2"
            options={pageSizeOptions}
            isMulti={false}
            placeholder="Page Size"
            onChange={handlePageSizeUpdate}
            value={pageSizeOptions.find((option) => option.value === pageSize)}
          />
        </div>
      </div>
      <div className="card-body pt-0 pb-4">
        <div className="table-responsive">
          <table
            className="table to-do-table align-middle table-row-dashed fs-6 gy-5 gs-7"
            id="report-table"
          >
            <thead>
              <tr className="text-start fw-bold fs-7 text-uppercase gs-0 colReorder">
                {header.map((item, i) => (
                  <th key={i} className="min-w-80px" data-header-key={item.key}>
                    <i className="fas fa-arrows-alt" title="Drag to Reorder"></i>&nbsp;&nbsp;{item.value}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="text-gray-600 fw-semibold">
              {reportsData?.length > 0
                ? reportsData.map((item, i) => (
                    <tr key={i}>{getTableDataForReportsTable(item)}</tr>
                  ))
                : null}
            </tbody>
          </table>
        </div>
      </div>
      <BSModalComponent
        modalBody={modalBody}
        show={modalShow}
        setShow={setModalShow}
        modalHeader={modalHeader}
      />
    </div>
  );
};
export default ManagerReportsTable;
